import React from "react";
import { Navigate } from "react-router-dom";
import Loading from "react-fullscreen-loading";
import { useAuth } from "./AuthContext";

// Consumes the centrally-verified session from AuthContext. Only resellers
// are permitted on routes wrapped in this guard.
export const ResellerRoute = ({ children }) => {
  const { status, userType } = useAuth();

  if (status === "loading") {
    return <Loading loading={true} background="#fff" loaderColor="#883484" />;
  }
  if (status === "anon") {
    return <Navigate to="/signin" replace />;
  }
  if (userType === "reseller") {
    return children;
  }
  if (userType === "user") {
    return <Navigate to="/user/dashboard" replace />;
  }
  // Covers every admin-portal role — admin, sales, and any role created later.
  if (userType === "admin") {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return <Navigate to="/signin" replace />;
};
